/* HiFuture — homepage motion layer (scroll reveal, count-up, parallax).
   Loaded only on the index template. Everything is gated on
   prefers-reduced-motion and degrades to fully-visible content without JS. */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced) return;

  document.documentElement.classList.add('hf-motion-ready');

  /* ---------- Scroll reveal ---------- */
  var revealTargets = [];

  function collectReveals() {
    var sections = document.querySelectorAll('.shopify-section');
    sections.forEach(function (section) {
      // Headings + direct content blocks inside each home section
      var picks = section.querySelectorAll(
        'h1, h2, h3, .hf-lux-content, [class*="card"], [class*="tile"], [class*="stat"], [class*="item"]'
      );
      var count = 0;
      picks.forEach(function (el) {
        if (count >= 12) return;                 // cap per section, keeps it snappy
        if (el.closest('.hf-reveal')) return;    // no nested reveals
        if (el.getBoundingClientRect().height === 0) return;
        el.classList.add('hf-reveal');
        el.style.setProperty('--hf-reveal-delay', (count % 6) * 70 + 'ms');
        revealTargets.push(el);
        count++;
      });
    });
  }

  /* ---------- Stat count-up ---------- */
  var COUNT_RE = /^([\d\s .,]+)\s*([KM]?\+?)$/;

  function animateCount(el) {
    var m = el.textContent.trim().match(COUNT_RE);
    if (!m) return;
    var target = parseFloat(m[1].replace(/[\s ,]/g, ''));
    if (!isFinite(target) || target <= 0) return;
    var suffix = m[2] || '';
    var start = null;
    var DURATION = 1300;
    el.classList.add('hf-countup');
    function frame(ts) {
      if (start === null) start = ts;
      var t = Math.min(1, (ts - start) / DURATION);
      var eased = 1 - Math.pow(1 - t, 3); // easeOutCubic
      var val = Math.round(target * eased);
      el.textContent = String(val) + suffix;
      if (t < 1) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  function collectCounts() {
    // Only inside the "global presence" style sections (ids contain global/stat)
    var scopes = document.querySelectorAll(
      '[id*="global"], [class*="global"], [class*="stats"]'
    );
    var found = [];
    scopes.forEach(function (scope) {
      scope.querySelectorAll('span, div, strong, h3, h2').forEach(function (el) {
        if (el.children.length > 0) return;
        if (COUNT_RE.test(el.textContent.trim()) && el.textContent.trim().length <= 8) {
          found.push(el);
        }
      });
    });
    return found;
  }

  /* ---------- Observer ---------- */
  var counted = new WeakSet();
  var countEls = [];

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('hf-in');
      if (countEls.indexOf(entry.target) !== -1 && !counted.has(entry.target)) {
        counted.add(entry.target);
        animateCount(entry.target);
      }
      io.unobserve(entry.target);
    });
  }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });

  /* ---------- Hero parallax (subtle) ---------- */
  function initParallax() {
    var media = document.querySelectorAll('.hf-lux-media-inner');
    if (!media.length) return;
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var y = window.scrollY;
        media.forEach(function (el) {
          if (y < window.innerHeight * 1.2) {
            el.style.setProperty('translate', '0 ' + (y * 0.06).toFixed(1) + 'px');
          }
        });
        ticking = false;
      });
    }, { passive: true });
  }

  /* ---------- Hover lift on obvious cards ---------- */
  function initHoverLift() {
    document
      .querySelectorAll('[class*="category-card"], [class*="lifestyle"] a, [class*="grid"] a[href*="/products/"]')
      .forEach(function (el) {
        el.classList.add('hf-hover-lift');
      });
  }

  function init() {
    collectReveals();
    countEls = collectCounts();
    countEls.forEach(function (el) {
      if (!el.classList.contains('hf-reveal')) {
        el.classList.add('hf-reveal');
        revealTargets.push(el);
      }
    });
    revealTargets.forEach(function (el) { io.observe(el); });
    initParallax();
    initHoverLift();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
